export const BASE_URL_ORDRR = process?.env?.REACT_APP_API_URL;
export const NOMINATIM_URL =
  "https://nominatim.openstreetmap.org/?format=json&limit=1";

export const API_URLS = {
  // Auth
  getRegisterDetails: "/v1/auth/register",
  getLoginDetails: "/v1/auth/login",
  saveUserActivation: "/v1/auth/activation",
  getForgotDetails: "/v1/auth/forgot_password",
  // Account
  getSeceruityQue: "/v1/auth/security_questions",
  getProfileDetails: "/v1/auth/profile",
  saveProfileDetails: "/v1/auth/update_profile",
  changePasswordDetails: "/v1/auth/reset_password",
  // SetupWizard
  getStartedDetails: "/v1/auth/get_started",
  getSetupDetails: "/v1/auth/setup_wizard",
  saveRequestApi: "/v1/auth/save_api_request",
  saveSetupZero: "/v1/auth/setup_zero",
  saveSetupOne: "/v1/auth/setup_one",
  saveSetupTwo: "/v1/auth/setup_two",
  saveSetupThree: "/v1/auth/setup_labor",
  saveSetupFour: "/v1/auth/step_four",
  saveSetupFive: "/v1/auth/step_five",
  saveSetupSix: "/v1/auth/step_six",
  saveSetupSeven: "/v1/auth/step_seven",
  saveSetupEight: "/v1/auth/step_eight",
  saveSetupNine: "/v1/auth/step_nine",
  checkTaxYear: "/v1/auth/checkTaxYear",
  getTaxYearEndDate: "/v1/auth/getTaxYearEndDate",
  saveAccountingPeriod: "/v1/auth/addAp",
  editAccountingPeriod: "/v1/auth/editAp",
  savePayrollFrequency: "/v1/auth/addPayrollFrequency",
  editPayrollFrequency: "/v1/auth/editFrequency",
  getAccrualTypes: "/v1/auth/getAccrualTypes",
  saveLeaveRule: "/v1/auth/addLcr",
  editLeaveRule: "/v1/auth/editLcr",
  saveOvertimeRule: "/v1/auth/addOr",
  editOvertimeRule: "/v1/auth/editOr",
  saveMealRule: "/v1/auth/addMar",
  editMealRule: "/v1/auth/editMar",
  saveIncentiveRule: "/v1/auth/addIar",
  editIncentiveRule: "/v1/auth/editIar",
  saveBlackoutRule: "/v1/auth/addBod",
  editBlackoutRule: "/v1/auth/editBod",
  savePerformanceRule: "/v1/auth/addPar",
  editPerformanceRule: "/v1/auth/editPar",
  deleteLaborRule: "/v1/auth/delete_rules",
  saveUploadStaff: "/v1/auth/upload_staff",
  downloadStaffTemplate: "/v1/auth/download_file/staff",
  saveUploadPayee: "/v1/auth/upload_payees",
  downloadPayeeTemplate: "/v1/auth/download_file/payee",
  backButtonHandler: "/v1/auth/update_last_step",
  applyPromoWizard: "/v1/auth/apply_promocode",
  removePromoWizard: "/v1/auth/remove_promocode",
  removeUploadStaff: "/v1/auth/remove_staff",
  removeUploadPayee: "/v1/auth/remove_payee",
  getStateDetails: "/v1/auth/get_states",
  /* 
    Settings 
  */
  /* account - settings */
  // account management
  getAccountSetting: "/v1/auth/account_settings",
  saveUploadAccLogo: "/v1/auth/upload_logo",
  getCompanySetting: "/v1/auth/company_settings",
  saveUploadAccDocument: "/v1/auth/updateDocument",
  deleteAccountingDocument: "/v1/auth/deleteAccountingDocument",
  updateAccPeriodStatus: "/v1/auth/updatePostingPeriodStatus",
  saveScheduleCompanyName: "/v1/auth/schedule_company_name",
  getScheduleCompanyName: "/v1/auth/get_scheduled_company_name",
  getCodeList: "/v1/auth/code_list",
  saveCodeData: "/v1/auth/add_code",
  deleteCodeDetails: "/v1/auth/delete_code",
  getAccountManagement: "/v1/auth/account_details",
  saveAccountManagementData: "/v1/auth/save_account_management",
  updateAccountAdminData: "/v1/auth/upload_account_admin",
  updatePlanCostData: "/v1/auth/update_plan_cost",
  updatePlanTopupData: "/v1/auth/update_plan_topup",
  updatePosCountData: "/v1/auth/update_pos_count",
  getOwnerSubAccData: "/v1/auth/getPaymentOwnerSubAccounts",
  savePaymentInfoData: "/v1/auth/save_payment_info",
  cancelAccountData: "/v1/auth/cancel_account",
  getInvoiceListData: "/v1/auth/invoice_list",
  getInvoiceDetailsData: "/v1/auth/show_invoice",
  // setting - user management
  getUserManagementData: "/v1/auth/user_management",
  getMerchantUserListData: "/v1/auth/merchant_user_listing",
  updateUserManageData: "/v1/auth/user_management",
  addLinkedEmployeeData: "/v1/auth/add_linked_employee",
  getPermissionGroupListData: "/v1/auth/permission_group_url",
  // setting - cluster
  getClusterSetting: "/v1/auth/cluster_settings",
  addClusterDetails: "/v1/auth/add_cluster",
  editClusterDetails: "/v1/auth/edit_cluster",
  getClusterModules: "/v1/auth/get_cluster_modules",
  addClusterAccess: "/v1/auth/add_cluster_access",
  editClusterAccess: "/v1/auth/edit_cluster_access",
  addClusterStore: "/v1/auth/add_edit_stores",
  /* finance - settings */
  // general settings
  getFinanceGeneralDetails: "/v1/finance/general_setting",
  getFinanceSaleDetails: "/v1/finance/general_setting_sales",
  savePaymentMethodDetails: "/v1/finance/addPm",
  updatePaymentMethodDetails: "/v1/finance/editPm",
  deletePaymentMethodDetails: "/v1/finance/deletePm",
  udpatePaymentMethodOrder: "/v1/finance/update_pm_ordering",
  getGroupAccDetails: "/v1/finance/get_ap_accounts",
  saveServicePeriodDetails: "/v1/finance/addSp",
  updateServicePeriodDetails: "/v1/finance/editSp",
  deleteServicePeriodDetails: "/v1/finance/deleteSp",
  saveSaleTypeDetails: "/v1/finance/addSt",
  updateSaleTypeDetails: "/v1/finance/editSt",
  deleteSaleTypeDetails: "/v1/finance/deleteSt",
  saveSaleGroupDetails: "/v1/finance/addSg",
  deleteSaleGroupDetails: "/v1/finance/deleteSg",
  saveChannelDetails: "/v1/finance/addChannel",
  updateChannelDetails: "/v1/finance/editChannel",
  deleteChannelDetails: "/v1/finance/deleteChannel",
  getPublicHolidayDetails: "/v1/finance/general_setting_holiday",
  savePublicHolidayDetails: "/v1/finance/add_store_holiday",
  deletePublicHolidayDetails: "/v1/finance/delete_store_holiday",
  updateMatrixSetting: "/v1/finance/updateMatrix",
  getMasterSettingDetails: "/v1/finance/master_settings/details",
  savePmMasterSettingDetails: "/v1/finance/master_settings/add_payment_method",
  updatePmMasterSettingDetails:
    "/v1/finance/master_settings/edit_payment_method",
  updatePmMasterSettingStatusDetails:
    "/v1/finance/master_settings/update_payment_method_status",
  refreshPmMasterSettingDetails:
    "/v1/finance/master_settings/refresh_payment_method",
  saveSalesMasterSettingDetails: "/v1/finance/master_settings/add_sales_type",
  updateSalesMasterSettingDetails:
    "/v1/finance/master_settings/edit_sales_type",
  updateSalesMasterSettingStatusDetails:
    "/v1/finance/master_settings/update_sales_type_status",
  refreshSalesMasterSettingDetails:
    "/v1/finance/master_settings/refresh_sales_type",
  saveServicePeriodsMasterSettingDetails:
    "/v1/finance/master_settings/add_service_period",
  updateServicePeriodsMasterSettingDetails:
    "/v1/finance/master_settings/edit_service_period",
  updateServicePeriodsMasterSettingStatusDetails:
    "/v1/finance/master_settings/update_service_period_status",
  refreshServicePeriodsMasterSettingDetails:
    "/v1/finance/master_settings/refresh_service_period",
  saveChannelsMasterSettingDetails: "/v1/finance/master_settings/add_channel",
  updateChannelsMasterSettingDetails:
    "/v1/finance/master_settings/edit_channel",
  updateChannelsMasterSettingStatusDetails:
    "/v1/finance/master_settings/update_channel_status",
  refreshChannelsMasterSettingDetails:
    "/v1/finance/master_settings/refresh_channel",

  //chart of accounts
  getFinanceChartOfAccSettingDetails: "/v1/finance/coa/chart_of_accounts",
  getFinanceAccDetails: "/v1/finance/coa/getAccounts",
  downloadAllFinanceAccDetail: "/v1/finance/coa/download_all_accounts",
  addFinanceAccDetail: "/v1/finance/coa/accounts",
  addFinanceSubAccDetail: "/v1/finance/coa/addSubAccount",
  getUpdateFinanceSubAccDetail: "/v1/finance/coa/subAccounts",
  getSubAccTransactionsDetails: "/v1/finance/coa/subAccountsTransactions",
  getAddTransSubAccDetail: "/v1/finance/coa/addTrans",
  getDebitCreditAccDetails: "/v1/finance/coa/getDCAccounts",
  saveAccTransaction: "/v1/finance/coa/addTrans",

  // Forecast
  getForecastSettingsDetail: "/v1/finance/fs_designs/finance_forecast",
  getForecastRulesDetail: "/v1/finance/fs_designs/get_forecast_rule",
  getApplicableQuarterDetail: "/v1/finance/fs_designs/get_applicable_quarter",
  saveForecastSettingsDetail: "/v1/finance/fs_designs/finance_forecast",
  editFinanceRuleDetail: "/v1/finance/fs_designs/update_forecast",

  // Reconcile
  getReconsileDetail: "/v1/finance/finance_reconcile",
  saveReconsileDetail: "/v1/finance/add_reconcile_account",
  deleteReconsileDetail: "/v1/finance/delete_reconcile_rule",
  getReconsileUploadDetail: "/v1/finance/finance_reconcile_upload_settings",

  // Order settings
  orderSettings: "/v1/trade/order_settings",
  orderTransferData: "/v1/trade/transfer_settings",
  postOrderTransferData: "/v1/trade/transfer_settings",
  secondAccountData: "/v1/trade/get_second_accounts",
  addTransferAccount: "/v1/trade/add_entity",
  transferAccountEditDetails: "/v1/trade/edit_entity/",
  updateTransferAccountStatus: "/v1/trade/update_setting_status",
  editTransferAccount: "/v1/trade/edit_entity/",
  // updateTransferAccountStatus: "/v1/trade/transfer_settings",

  /* 
    Menu Engineer 
  */
  /* ingredients */
  getMenuIngredientDetails: "/v1/menu/ingredients",
  addMenuIngredientDetail: "/v1/menu/add_ingredient",
  checkSupplierDetails: "/v1/menu/check_supplier",
  saveStorageAreaDetails: "/v1/menu/add_storage_area",
  getConversionMultiplierDetails: "/v1/menu/get_conversion_multiplier",
  getInventoryUomDetail: "/v1/menu/get_inventory_uom",
  saveBackupIngredientDetail: "/v1/menu/add_backup_ingredient",
  getBackupIngredientDetail: "/v1/menu/get_backup_ingredient",
  getEditIngredientDetail: "/v1/menu/edit_ingredient",
  getIngrRecMenuPendingApprovalDetail:
    "/v1/menu/ingr_rec_menu_pending_approval",
  changeIngredientStatusDetail: "/v1/menu/change_ingredient_status",
  changePendIngredientStatusDetail: "/v1/menu/approve_temp_ingredients",
  changeIngredientStatusDetail: "/v1/menu/change_ingredient_status",
  /* recipes */
  getMenuRecipeDetails: "/v1/menu/recipes",
  addMenuRecipeDetail: "/v1/menu/add_recipe",
  getEditRecipeDetail: "/v1/menu/edit_recipe",
  getMeasurementUnitDetails: "/v1/menu/get_mu",
  getRecipeCostPriceDetails: "/v1/menu/get_cpr",
  getRecipeMultiplierDetails: "/v1/menu/get_multi",
  getRecipeUnitPriceDetails: "/v1/menu/get_unit_price",
  changePendRecipeStatusDetail: "/v1/menu/approve_temp_recipes",
  /* Menu Item */
  getMenuItemsDetails: "/v1/menu/menu_items",
  getMenuItemSubClassDetails: "/v1/menu/get_sub_class",
  getMenuItemSubCategoryDetails: "/v1/menu/get_sub_categories",
  updateMenuItemClassDetails: "/v1/menu/update_class",
  updateMenuItemCategoryDetails: "/v1/menu/update_category",
  updateMenuItemStatusDetails: "/v1/menu/deactivate_menu_items",
  editMenuItemLifespanDetails: "/v1/menu/edit_menu_item_lifespan",
  updateMenuItemLifespanDetails: "/v1/menu/update_menu_item_lifespan",
  getAddMenuItemDetails: "/v1/menu/add_menu_item",
  getMenuItemCaDetails: "/v1/menu/get_ca",
  getMenuMeasurementUnitDetails: "/v1/menu/get_measurement_units",
  getAddMenuPricingsDetails: "/v1/menu/add_pricings",
  saveAddMenuPricingsDetails: "/v1/menu/add_mi_session_pay",
  getMenuPricingListDetails: "/v1/menu/update_mi_pay_index",
  getEditMenuPricingsDetails: "/v1/menu/edit_pricings",
  deleteMenuPricingsDetails: "/v1/menu/delete_payment",
  getMenuListDetails: "/v1/menu/get_menus",
  getCostPerItemDetails: "/v1/menu/get_cost_per_menu_item",
  getEditMenuItemDetails: "/v1/menu/edit_menu_item",
  // EDIT MENU ITEM PAGE
  saveEditMenuPricingsDetails: "/v1/menu/update_mi_data",
  getEditMenuPricingListDetails: "/v1/menu/update_mi_list",
  getEditMenuEditPricingsDetails: "/v1/menu/edit_pricing_in_edit",
  getMenuEditPricingsDetails: "/v1/menu/add_pricing_in_edit",

  deleteEditMenuPricingsDetails: "/v1/menu/delete_pricing",
  // CUSTOM MODIFIERS
  getMenuItemModifiersDetails: "/v1/menu/menu_items/modifiers",

  saveMenuItemModifierDetails: "/v1/menu/add_modifier",

  deleteMenuItemModifierDetails: "/v1/menu/delete_modifier",
  deleteMenuBundleItemModifierDetails: "/v1/menu/delete_modifier_bundle",
  getCopyBundleModifierDetails: "/v1/menu/copy_bundle_modifier",
  getBundleModifierForCopyDetails: "/v1/menu/get_bundle_modifier_for_copy",
  saveCopyBundleModifier: "/v1/menu/copy_bundle_modifier",
  editMenuBundleItemModifierDetails: "/v1/menu/edit_modifier_bundle",

  // Onlife
  getOnlifeData: "/v1/extras/onlife_sites/setup",
  postMerchantOnlifeData: "/v1/extras/onlife_sites/setup",
  postCompetitorOnlifeData: "/v1/extras/onlife_sites/setup",
  deleteCompetitorOnlifeData: "/v1/extras/onlife_sites/delete_competitor",

  // posMaster
  getPosMasterData: "/v1/pos/pos_settings",
  getPosMasterFormOptions: "/v1/pos/pos_master_detail",
  postPosMasterActiveStatus: "v1/pos/delete_pos_master",

  postAddPosMasterFormData: "/v1/pos/pos_master_detail",
  getEditPosMasterFormData: "/v1/pos/edit_pos_master/",
  postEditPosMasterFormData: "/v1/pos/edit_pos_master/",

  postPosIntegrationSetting: "/v1/pos/add_pos_setting_session",
  // getPosIntegrationSettingData: "/v1/pos/update_pos_setting_index",
  getApplicableModule: "/v1/pos/get_pos_configs/",
  getFrequency: "/v1/pos/get_pos_freq_configs/",

  // layout master
  getRoomsLayoutData: "/v1/pos/room_layout",
  postAddRoomLayout: "/v1/pos/add_room_layout",

  getEditRoomLayout: "/v1/pos/edit_room_layout/",
  postEditRoomLayout: "/v1/pos/edit_room_layout/",

  deleteRoomLayout: "/v1/pos/delete_room_layout",

  // table master
  getTableMasterData: "/v1/pos/table_master",
  getEditTableMasterFormData: "/v1/pos/edit_table_master/",
  postEditTableMasterFormData: "/v1/pos/edit_table_master/",
  getTableMasterFormData: "/v1/pos/add_table_master",
  postAddTableMasterFormData: "/v1/pos/add_table_master",
  postAddRoomInForm: "/v1/pos/update_room",

  // hardware master
  getHardwareMasterData: "/v1/pos/hardware_master",
  postHardwareMasterData: "/v1/pos/add_hardware_master",
  getHardwareMasterFormData: "/v1/pos/add_hardware_master",
  getQualificationSelection: "/v1/pos/get_qualification_selection?q_level=",

  getEditHardwareMasterData: "/v1/pos/edit_hardware_master/",
  postEditHardwareMasterData: "/v1/pos/edit_hardware_master/",

  getHardwareDetailsSession: "/v1/pos/get_hardware_detail_session",
  postHardwareDetailsSession: "/v1/pos/add_edit_hardware_detail_session",

  getInventoryGeneralSettingsData: "/v1/inventory/inventory_general_settings",
  postInventoryGeneralSettingsData: "/v1/inventory/inventory_general_settings",

  getInventoryCountSettingsData: "/v1/inventory/inventory_count_settings",
  postAddInventoryCountSettingsData: "/v1/inventory/add_count_setting",

  postGeneralCountSettings: "/v1/inventory/save_general_count_settings",

  deleteInventoryCountSettingsData: "/v1/inventory/delete_count_setting",

  getEditInventoryCountSettingsData: "/v1/inventory/edit_count_setting/",
  postEditInventoryCountSettingsData: "/v1/inventory/edit_count_setting/",

  getLabourAddEmployeeFormData: "/v1/labor/add_employee",
  postLabourAddEmployeeFormData: "/v1/labor/add_employee",

  getLabourEmployeeList: "/v1/labor/employee_list",

  getEditLabourEmployeeData: "/v1/labor/edit_employee/",
  postEditLabourEmployeeData: "/v1/labor/edit_employee/",

  getEmployeeBankingInfo: "/v1/labor/update_bi_index",
  postEmployeeBankingInfo: "/v1/labor/add_session_bi",
  deleteEmployeeBankingInfo: "v1/labor/delete_banking",

  getEmployeeDocumentInfo: "/v1/labor/update_do_index",
  postEmployeeDocumentInfo: "/v1/labor/add_session_do",
  deleteEmployeeDocumentInfo: "/v1/labor/delete_session_document",

  getEmployeeTaxDocumentInfo: "/v1/labor/update_tax_do_index",
  postEmployeeTaxDocumentInfo: "/v1/labor/add_session_tax_do",
  deleteEmployeeTaxDocumentInfo: "/v1/labor/delete_tax_document",

  getEmployeeDependentsInfo: "/v1/labor/update_dependents_index",
  postEmployeeDependentsInfo: "/v1/labor/add_session_dependents",
  deleteEmployeeDependentsInfo: "/v1/labor/delete_dependents",

  getClipBoardData: "/v1/extras/features/setup?day_time=",
  postClipBoardData: "/v1/extras/features/setup",

  postClipBoardDescription: "/v1/extras/features/add_description",
  deleteClipBoardDescription: "/v1/extras/features/delete_description",

  getPromotions: "/v1/menu/promotions",
  deletePromotion: "/v1/menu/delete_pos_promotion",

  getPromotionsFormData: "/v1/menu/add_promotion",
  postAddPromotionData: "/v1/menu/add_promotion",

  getEditPromotionData: "/v1/menu/edit_promotion/",
  postEditPromotionData: "/v1/menu/edit_promotion/",

  postPromoGroup: "/v1/menu/add_promogroup",
  editPromotionPeriod: "/v1/menu/add_edit_promotion_period",
  addPromotionPeriod: "/v1/menu/add_edit_promotion_period_session",
  getAddPromotionPeriodData: "/v1/menu/get_period_session",
  deletePromotionPeriod: "/v1/menu/delete_period",
  getQualificationCriteria: "/v1/menu/qualification_criteria",
  postQualificationCriteria: "/v1/menu/add_qualification_session",

  getMenuPricingDetails: "/v1/menu/menu_pricing_pos",
  postMenuPricingDetails: "/v1/menu/menu_pricing_pos",

  getScheduledMenuPricingDetails: "/v1/menu/scheduled_price_list",
  postScheduledMenuPricingDetails: "/v1/menu/scheduled_price_update_pos",
  deleteScheduledMenuItem: "/v1/menu/delete_menu_price_schedule",

  searchMenuByName: "/v1/menu/get_menus_lists?search=",
  getSalesType: "/v1/menu/get_menu_item_price",

  // qr ordering
  getQrOrderData: "/v1/pos/qr_orderings",
  postQrOrderData: "/v1/pos/qr_orderings",

  postPdfMenu: "/v1/pos/add_pdf_menu",
  editPostPdfMenuData: "/v1/pos/edit_pdf_menu/",

  getMenuSequencingData: "/v1/pos/menu_sequencing",
  postMenuSequencingData: "/v1/pos/menu_sequencing",

  getQrList: "/v1/pos/qr_list",
  downloadQrList: "/v1/pos/download_qr_codes",
  downloadSelectedQr: "/v1/pos/download_table_qrs",
  regenerateSelectedQr: "/v1/pos/re_generate_qrs",
  refreshTableQrCode: "/v1/pos/refresh_table_qrcode",

  // ordrr online
  getOrdrrOnlineMenuSequencingData: "/v1/pos/ordrr_onlines/menu_sequencing",
  postOrdrrOnlineMenuSequencingData: "/v1/pos/ordrr_onlines/menu_sequencing",

  getOrdrrOnlineData: "/v1/pos/ordrr_onlines",
  postOrdrrOnlineData: "/v1/pos/ordrr_onlines",

  getDeliveryPartnerData: "/v1/pos/ordrr_onlines/delivery_partners",
  postDeliveryPartnerData: "/v1/pos/ordrr_onlines/delivery_partners",
  addDeliveryPartner: "/v1/pos/add_delivery_partner",
  editDeliveryPartner: "/v1/pos/edit_delivery_partner/",
  deleteDeliveryPartner: "/v1/pos/delete_delivery_partner",

  getApiKeyListing: "/v1/auth/api_keys_listing",
  postConfirmPassword: "/v1/auth/confirm_password",
  postDeleteApiKey: "/v1/auth/delete_key",
  postGenerateApiKey: "/v1/auth/generate_api_key",
  getIntegrationData: "/v1/auth/integrations",
  postPackageStatus: "/v1/grab/change_package_status",
  getIntegrationEditData: "/v1/grab/edit_integration_details/1",
  postIntegrationEditData: "/v1/grab/edit_integration_details/1",
  postPauseStore: "/v1/grab/pause_store",

  // finance
  // sales
  getSalesData: "/v1/sales/sales",
  getOtherIncomeDataOptions: "/v1/sales/other_income",
  postOtherIncomeData: "/v1/sales/other_income/",
  postOtherIncomeEditData: "/v1/sales/edit_other_income/",

  // order payments
  getOrderPaymentsData: "/v1/sales/order_payments",
  getOrderPaymentsItemData: "/v1/sales/item_listing/",
  getOrderPaymentsBundleItemData: "/v1/sales/bundle_item_listing",
  getOrderPaymentsComponentData: "/v1/sales/item_components",
  getOrderPaymentsComponentData: "/v1/sales/item_components",
  getOrderPaymentsViewBillsData: "/v1/sales/view_bills/",
  getOrderPaymentsBillsItemData: "/v1/sales/item_details",
  getOrderPaymentsBillsComponentData: "/v1/sales/component_details",
  postOrderPaymentsPrintBill: "/v1/sales/receipt_print",

  // refunds
  getRefundsData: "/v1/sales/refunds",
  getBillData: "/v1/sales/bills",
  getInnerMenuItemsData: "v1/sales/inner_menu_item",
  getInnerComponentData: "/v1/sales/inner_components",

  // voids
  getVoidsData: "/v1/sales/voids",
  // disocunts
  getDiscountsData: "/v1/sales/discounts",
  // tips
  getTipsData: "/v1/sales/tips",
  // promotions
  getPromotionsData: "/v1/sales/promotions_sales",
  getPromotionsSalesData: "/v1/sales/view_sale_details/",
  // expenses
  getExpensesData: "/v1/sales/expenses",
  // payments
  getPaymentsData: "/v1/sales/payments",
  getAddPaymentsFormData: "/v1/sales/add_payment",
  postAddPaymentsFormData: "/v1/sales/add_payment",
  getExpenseTypeData: "/v1/sales/getExpenseType",
  getInvoicesData: "/v1/sales/getInvoices",
  getPayTradeLiabilityData: "/v1/sales/getPayTradeLiability",
  getPayOtherDebtData: "/v1/sales/getPayOtherDebt",
  getBuyAssetData: "/v1/sales/getBuyAsset",
  getPaymentAccountData: "/v1/sales/getPaymentAccount/",
  getAddAssetData: "/v1/sales/addAsset/",
  postAddAssetData: "/v1/sales/saveAsset",
  postDeleteAddAssetData: "/v1/sales/deleteAsset",
  getApLiabilityData: "/v1/sales/getApLiabilityData",
  getViewPaymentData: "/v1/sales/view_payment/",
  getEditPaymentData: "/v1/sales/edit_payment/",
  postEditPaymentData: "/v1/sales/edit_payment/",
  getPendingPaymentsData: "/v1/sales/payments/pending",
  getApprovedPaymentsData: "/v1/sales/payments/approved",
  postApprovedPaymentsData: "/v1/sales/payments/approved",
  getSubmittedPaymentsData: "/v1/sales/payments/submitted",
  getRejectedPaymentsData: "/v1/sales/payments/rejected",

  // customers
  getCustomersData: "/v1/trade/customers",
  postCustomersData: "/v1/trade/add_customer",
  postCustomersEditData: "/v1/trade/add_customer/",
  getDownloadCustomersData: "/v1/trade/export_customers",
  getCustomersFormOptions: "/v1/trade/add_customer",
  getCustomersFormStates: "/v1/labor/get_states/",
  postCustomerFile: "/v1/trade/import_customers",
  getCustomerEditData: "/v1/trade/add_customer/",

  // payee
  getPayeeList: "/v1/trade/payees",
  getDownloadPayeeList: "/v1/trade/download_payees",
  postUploadPayeeList: "/v1/trade/import_customers",
  getAddPayeeData: "/v1/trade/add_payee",
  postAddPayeeData: "/v1/trade/add_payee",
  getPayeeLinkedEmployee: "/v1/trade/getLinkedEmployees",
  getPayeeExpenseAccount: "/v1/trade/getExpenseAccountsPayee",
  getPayeeOptions: "/v1/trade/add_customer",
  getPayeeStates: "/v1/labor/get_states/",

  getEditPayeeData: "/v1/trade/edit_payee/",
  postEditPayeeData: "/v1/trade/edit_payee/",

  getPayeePaymentInfoOptions: "/v1/trade/getPaymentInfo/",
  getPayeePaymentInfoData: "/v1/trade/updatePayeePayIndex",
  postPayeePaymentInfoData: "/v1/trade/addPayeeSessionPay",
  postDeletePayeePaymentInfoData: "/v1/trade/deletePayment",

  getPayeeDocumentData: "/v1/trade/updateDoIndex",
  postPayeeDocumentData: "/v1/trade/addSessionDo",
  deletePayeeDocumentData: "/v1/trade/deleteDocument",

  getPayeeBankingInfoData: "/v1/trade/updatePayeeBiIndex",
  postPayeeBankingInfoData: "/v1/trade/addPayeeSessionBi",
  deletePayeeBankingInfoData: "/v1/trade/deleteBanking",
  postPayeeStatus: "/v1/trade/payee_status",

  addPayeePendingApprovalData: "/v1/trade/add_payee_pending_approval",

  // ar invoices
  postArInvoicesData: "/v1/trade/add_ar_invoices",
  getNewArInvoicesOptions: "/v1/trade/add_ar_invoices",

  getArInvoicesData: "/v1/trade/ar_invoices",
  getEditArInvoicesData: "/v1/trade/edit_ar_invoices/",
  postEditArInvoicesData: "/v1/trade/edit_ar_invoices/",

  getOutstandingArInvoicesData: "/v1/trade/ar_invoices/outstanding",
  getCancelledArInvoicesData: "/v1/trade/ar_invoices/cancelled",
  getPaidArInvoicesData: "/v1/trade/ar_invoices/paid",

  postCancelArInvoice: "/v1/trade/cancel_invoice",

  // finance receivables
  getReceivablesList: "/v1/sales/receivables",
  getReceivableDetails: "/v1/sales/receivables/details/",
  postReceivePayments: "/v1/sales/receive_payment",

  getCreditNoteList: "/v1/sales/credit_notes",

  // finance payables
  getFinancePayablesOutstanding: "/v1/sales/payables/outstanding",
  getFinanceApCreditNotes: "/v1/sales/ap_credit_notes",
  getApCreditNotesOption: "/v1/sales/add_ap_credit_note",
  getApCreditNotesTaxPercentage: "/v1/sales/get_tax_percentage/",
  postApCreditNotesData: "/v1/sales/add_ap_credit_note",
  getEditApCreditNotesData: "/v1/sales/ap_credit_note_view/",
  postCreditNotesAttachment: "/v1/sales/upload_attachment",

  // finance assests
  getFinanceAssets: "/v1/sales/assets",
  downloadFinanceAssets: "/v1/sales/downloadAssetData",

  downloadFinanceVoucher: "/v1/sales/download_excel/",
  getFinanceVouchers: "/v1/sales/vouchers",
  getFinanceVouchersList: "/v1/sales/voucher_list",
  getFinanceBalanceToIncome: "{{url}}/v1/sales/balance_to_income/",
};
